<template>
<div class="honesDetails">
  <div class="datailsWrap">
    <div class="honesDetailsItem">
      <span>商家：</span>
      <span>{{honesInfo.username}}</span>
    </div>
   
    <div class="honesDetailsItem">
      <span>地址：</span>
      <span>{{honesInfo.area}}</span>
    </div>
    <div class="honesDetailsItem">
      <span>电话：</span>
      <span>{{honesInfo.tell}}</span>
    </div>
  </div>
</div>
</template>

<script>
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';
export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {
      honesId: '',
      honesInfo: []
    }
  },
  props:{
    id:String
  },
  
 
  mounted() {
    
    this.getHonesInfoData();
  },
  methods: {
    async getHonesInfoData() {
      const result = await this.$http.home.getUserInfoByID({
      userID: this.id
    })
      if (result.code === 200) {
        this.honesInfo = result.data;

      } else {
        
        return
      }
    }
  },
  
}
</script>

<style lang="less">
.honesDetails {
  height: 100vh;

  .datailsWrap {
    height: 200px;
    padding: 20px 0;
    .honesDetailsItem {
      font-size: 30px;
    }
  }

  
}
</style>
